import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const SecurityCodeReview: React.FC = () => {
  const sections = [
    {
      title: 'Expert Security Code Review',
      content: 'Our security code review services identify vulnerabilities, security flaws, and compliance issues in your applications before they reach production. Our certified security experts conduct thorough manual and automated reviews to ensure your code meets the highest security standards.',
      benefits: [
        'Manual and automated code analysis',
        'OWASP Top 10 vulnerability detection',
        'Secure coding best practices review',
        'Compliance validation and reporting',
        'Developer training and remediation guidance'
      ]
    }
  ];

  return (
    <ServiceTemplate
      title="Security Code Review"
      subtitle="Comprehensive security code reviews to identify vulnerabilities and ensure secure application development practices."
      sections={sections}
    />
  );
};

export default SecurityCodeReview;

